import React, { useEffect, useRef } from "react";
import { changeTagStyle } from "../../utils/changeTagStyle";
import { spacing, uiColors, typographyColors } from "./theme";

function applyEmptyLineStyles(element) {
  if (!element) return;

  const allParagraphs = element.querySelectorAll("p");
  allParagraphs.forEach((p) => {
    const isInsideTable = p.closest("table");
    
    if (!isInsideTable) {
      const textContent = p.textContent?.trim() || "";
      const hasOnlyBr = p.children.length === 1 && p.querySelector("br");
      
      if (textContent === "" || hasOnlyBr) {
        p.style.minHeight = "1.5em";
        p.style.lineHeight = "1.5";
      }
    }
  });

  const brElements = element.querySelectorAll("br");
  brElements.forEach((br) => {
    const parent = br.parentElement;
    if (parent && parent.tagName === "P") {
      const parentText = parent.textContent?.trim() || "";
      if (parentText === "" && parent.children.length === 1) {
        parent.style.minHeight = "1.5em";
        parent.style.lineHeight = "1.5";
      }
    }
  });
}

function applyTableStyles(element) {
  if (!element) return;

  const tableWrappers = element.querySelectorAll(".table-wrapper");
  tableWrappers.forEach((wrapper) => {
    wrapper.style.overflowX = "auto";
    wrapper.style.overflowY = "auto";
    wrapper.style.marginTop = spacing.m;
    wrapper.style.marginBottom = spacing.m;
    wrapper.style.maxWidth = "100%";
  });

  const tables = element.querySelectorAll("table");
  tables.forEach((table) => {
    table.style.width = "100%";
    table.style.borderCollapse = "collapse";
    table.style.tableLayout = "auto";
    table.style.margin = "0";
    table.style.display = "table";
    table.style.borderSpacing = "0";

    const ths = table.querySelectorAll("th");
    ths.forEach((th) => {
      th.style.backgroundColor = uiColors.contentCards;
      th.style.border = `1px solid ${uiColors.border}`;
      th.style.padding = spacing.s;
      th.style.textAlign = "left";
      th.style.minWidth = "150px";
      th.style.fontWeight = "600";
      th.style.verticalAlign = "middle";
      th.style.color = typographyColors.defaultTitle;
    });

    const tds = table.querySelectorAll("td");
    tds.forEach((td) => {
      td.style.border = `1px solid ${uiColors.border}`;
      td.style.padding = spacing.s;
      td.style.minWidth = "150px";
      td.style.verticalAlign = "middle";
      td.style.color = typographyColors.defaultBody;
      td.style.backgroundColor = "transparent";
    });

    const ps = table.querySelectorAll("p");
    ps.forEach((p) => {
      p.style.margin = "0";
      p.style.padding = "0";
      p.style.lineHeight = "1.5";
    });
  });
}

export default function TipTapViewer({ content, className }) {
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current && content) {
      changeTagStyle(contentRef.current, "*", "fontFamily", null);
      applyTableStyles(contentRef.current);
      applyEmptyLineStyles(contentRef.current);
    }
  }, [content]);

  if (!content) {
    return null;
  }

  return (
    <div className={className}>
      <div
        ref={contentRef}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
}
